<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="pakbonnummer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Pakbonnummer </th>
        <td mat-cell *matCellDef="let row"> {{row.pakbonnummer}} </td>
    </ng-container>

	<ng-container matColumnDef="datumPakbon">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum pakbon </th>
        <td mat-cell *matCellDef="let row"> {{row.datumPakbon | date}} </td>
    </ng-container>

    <ng-container matColumnDef="factuur">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Factuur </th>
        <td mat-cell *matCellDef="let row"> {{row.factuur}} </td>
    </ng-container>
    
    <ng-container matColumnDef="project">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Project </th>
        <td mat-cell *matCellDef="let row"> {{row.project.code}} </td>
    </ng-container>

    <ng-container matColumnDef="klant">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Klant </th>
        <td mat-cell *matCellDef="let row"> {{row.project.relatie.naam1}} </td>
    </ng-container>

	<ng-container matColumnDef="verzendtarief">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Verzendtarief </th>
        <td mat-cell *matCellDef="let row"> {{row.verzendtarief?.omschrijving}} </td>
    </ng-container>

	<ng-container matColumnDef="verzendbedrag">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Verzendbedrag </th>
        <td mat-cell *matCellDef="let row"> € {{row.verzendbedrag?.toFixed(2)}} </td>
    </ng-container>

	<ng-container matColumnDef="opmerking">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Opmerking </th>
        <td mat-cell *matCellDef="let row"> {{row.opmerking}} </td>
    </ng-container>

</mg-table>
